module.exports = __webpack_public_path__ + "img/arrow_down_2.fc413ca8.svg";